import { StyledCell } from 'components/base/Table/Table.styles';
// eslint-disable-next-line no-unused-vars
import ProjectIcon from '../../ProjectIcon';
import Text from 'components/base/Text';

const NameCell = ({ filterSet }) => {
  return (
    <StyledCell>
      {/* Temporary in comment until we support multiple kinds of projects */}
      {/* <ProjectIcon filterSet={filterSet} /> */}
      <Text size='medium' ellipsisAfter='17rem'>
        {filterSet?.name}
      </Text>
    </StyledCell>
  );
};

export default NameCell;
